import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  page: {
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: 24,
    background: '#f4f6f8',
    boxSizing: 'border-box',
    textAlign: 'center',
  },
});
